import * as React from "react";
import * as ReactDOM from "react-dom";
import { OptionalLink } from "../optionalLink";

export interface IListViewItemProperties
{
    /**
     * Inline-Style zum überschreiben des Standard Styles.
     */
    style?: React.CSSProperties,

    /**
     * Kann die DataSource von dem der eigentliche Text stammt, enthalten.
     */
    dataSource?: any,

    /**
     * Anzeige Text.
     */
    text: string,

    /**
     * Link (react-router).
     */
    linkTo?: string,

    /**
     * Link.
     */
    externalLink?: string,

    /**
     * Gibt an, ob das Item selektiert ist.
     */
    isSelected?: boolean,

    /**
     * Gibt an, ob das Item abgeschaltet ist.
     */
    isDisabled?: boolean,

    /**
     * Wird ausgeführt, sobald auf das Item geklickt wird.
     */
    onClick?: (dataSource: any, e?: MouseEvent) => void
}

export class ListViewItem extends React.Component<IListViewItemProperties>
{
    /**
     * Führt die "onClick" Eigenschaft aus wenn diese gesetzt wurde.
     * @param e Das auslösende Ereignis.
     */
    private onClick = (e: React.MouseEvent<HTMLElement>) =>
    {
        var { dataSource, onClick } = this.props;
        onClick && onClick(dataSource, e.nativeEvent);
    }

    /**
     * Rendert die Komponente.
     */
    public render(): JSX.Element
    {
        const { style, dataSource, text, linkTo, externalLink, isSelected, isDisabled, onClick } = this.props;
        const attributes = {};

        // Klasse erstellen.
        var classNames: string[] = ["listview-item"];

        if (isSelected)
            classNames.push("listview-item--selected");

        if (isDisabled)
            classNames.push("listview-item--disabled");

        if (externalLink != null)
        {
            attributes["href"] = externalLink;
            attributes["target"] = "_blank";
        }

        return (
            <OptionalLink
                className={classNames.join(" ")}
                to={linkTo}
                style={style}
                onClick={onClick}
                {...attributes}>
                {text}
            </OptionalLink>
        );
    }
}